import axios from "axios";
import { getToken } from "./authService";
import { hideLoader } from "../helpers/loader";
import { NotificationManager } from "react-notifications";
import { UserDataContext } from "./../../context/userContext";

// A request can fail with no answer at all (offline, server restarting, blocked): there is then no
// error.response, and reading .data from it crashed the page (QA 2026-10-26). Always return something readable.
const errData = (error) =>
  (error && error.response && error.response.data) || {
    message: typeof navigator !== "undefined" && navigator.onLine === false
      ? "You seem to be offline. Check your connection and try again."
      : "We couldn’t reach TheNewspaperStand just now. Please try again.",
    data: {},
  };

// The sign-in stopped working. Ask once for the password (userContext shows the sheet), unless a newer sign-in has
// already replaced the token this request went out with: then the failure is old news and means nothing.
const SESSION_GONE = /token is invalid or expired/i;
const sessionGone = (error) => {
  if (!SESSION_GONE.test(String(errData(error).message || ""))) return false;
  const sent = String((error.config && error.config.headers && error.config.headers.Authorization) || "").replace(/^Bearer\s+/, "");
  if (sent === String(localStorage.getItem("token") || "")) window.dispatchEvent(new Event("tns:session-gone"));
  return true;
};

export let baseUrl = process.env.REACT_APP_BASE_URL;
// export let baseUrl = "https://api.thenewspaperstand.com";
// export let baseUrl = process.env.REACT_APP_BASE_URL;
// export let baseUrl = "http://d3898537932a.ngrok.io";

export const httpPost = async (url, postBody) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }
  try {
    const res = await axios.post(`${baseUrl}/api/${url}`, postBody, {
      headers: { Authorization: `Bearer ${localStorage.token}` },
    });
    return res.data;
  } catch (error) {
    hideLoader();

    sessionGone(error);
    if (errData(error).message === "Validation Error!") {
      NotificationManager.error(
        Object.values(errData(error).data).join("  ")
      );
      return;
    }
    return { er: errData(error) };
  }
};

export const httpPostData = async (url, postBody) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }

  try {
    const res = await axios.post(`${baseUrl}/api${url}`, postBody, {
      headers: {
        Authorization: `Bearer ${localStorage.token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    hideLoader();
    sessionGone(error);
    return { er: errData(error) };
  }
};

export const httpGet = async (url) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }
  try {
    const res = await axios.get(`${baseUrl}/api/${url}`, {
      headers: { Authorization: `Bearer ${localStorage.token}` },
    });
    return res.data;
  } catch (error) {
    hideLoader();
    if (sessionGone(error)) {
      return { er: errData(error).message };
    }
    if (errData(error).message === "Validation Error!") {
      NotificationManager.error(
        Object.values(errData(error).data).join("  ")
      );
      return;
    }
    return { er: errData(error) };
  }
};

export const httpPut = async (url, postBody) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }
  try {
    const res = await axios.put(`${baseUrl}/api/${url}`, postBody, {
      headers: { Authorization: `Bearer ${localStorage.token}` },
    });
    return res.data;
  } catch (error) {
    hideLoader();
    if (!sessionGone(error)) NotificationManager.error(errData(error).message || "Something went wrong. Please try again.");
    return { er: errData(error) };
  }
};

export const httpPatch = async (url, postBody) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }
  try {
    const res = await axios.patch(`${baseUrl}/api/${url}`, postBody, {
      headers: { Authorization: `Bearer ${localStorage.token}` },
    });
    return res.data;
  } catch (error) {
    hideLoader();
    if (!sessionGone(error)) NotificationManager.error(errData(error).message || "Something went wrong. Please try again.");
    return { er: errData(error) };
  }
};

export const httpDelete = async (url, postBody) => {
  if (!navigator.onLine) {
    return NotificationManager.error(
      "Please check your internet",
      "Opps!",
      3000
    );
  }
  try {
    const res = await axios.delete(`${baseUrl}/api/${url}`, {
      headers: { Authorization: `Bearer ${localStorage.token}` },
    });
    return res;
  } catch (error) {
    hideLoader();
    sessionGone(error);
    return { er: errData(error) };
  }
};
